import { useCallback } from 'react'
import { useParams } from 'react-router-dom'
import { useLingui } from '@lingui/react'
import { formatSkinName } from '../utils/formatSkinName'
import { Case, Prize, Shelf } from '../types'

export const useFormatSkinName = () => {
  const { lang } = useParams()

  return useCallback(
    (englishName: string | undefined) => {
      if (!englishName) return ''
      return formatSkinName(englishName, lang || 'en')
    },
    [lang],
  )
}

export const useFormatBoxName = () => {
  const { lang } = useParams()
  return useCallback(
    (box: Case | Prize | any) => {
      if (!box) return ''
      if ('base' in box) {
        return lang === 'zh' ? box?.base?.nameCn : box?.base?.name
      }
      return lang === 'zh' ? box?.boxInfo?.nameCn : box?.boxInfo?.name
    },
    [lang],
  )
}

export const useFormatShelfName = () => {
  const { lang } = useParams()
  return useCallback(
    (shelf: Shelf) => {
      return lang === 'zh' ? shelf?.nameCn : shelf?.name
    },
    [lang],
  )
}
